import React from "react";

export default ({ type }) => {
  return (
    <p className="card-types">
      <i
        className={
          type === "visa"
            ? "fa fa-cc-visa fa-2x"
            : "fa fa-cc-visa fa-2x working"
        }
      />
      <i
        className={
          type === "mast"
            ? "fa fa-cc-mastercard fa-2x"
            : "fa fa-cc-mastercard fa-2x working"
        }
      />
      <i
        className={
          type === "amex"
            ? "fa fa-cc-amex fa-2x"
            : "fa fa-cc-amex fa-2x working"
        }
      />
      <i
        className={
          type === "disc"
            ? "fa fa-cc-discover fa-2x"
            : "fa fa-cc-discover fa-2x working"
        }
      />
    </p>
  );
};
